"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSelectedPayCodeInPayCodeList = exports.updateSelectedPayCodeInPayDataList = exports.PayCodeSelection = exports.PAY_CODE_SELECTION_LABEL_TEST_ID = exports.PAY_CODE_SELECTION_TEST_ID = void 0;
const Select_1 = require("@amzn/atoz-web/Select");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const react_1 = __importDefault(require("react"));
const PayCodePolicyModal_1 = require("../../PayCodePolicyModal");
exports.PAY_CODE_SELECTION_TEST_ID = 'pay-code-selection';
exports.PAY_CODE_SELECTION_LABEL_TEST_ID = 'pay-code-selection-label';
const PayCodeSelection = (props) => {
    return (react_1.default.createElement(Col_1.Col, { gridGap: "S100" },
        react_1.default.createElement(Row_1.Row, { gridGap: "S100", alignItems: "Center" },
            react_1.default.createElement(Text_1.Label, { fontSize: "T100", color: "neutral70", htmlFor: exports.PAY_CODE_SELECTION_TEST_ID, id: exports.PAY_CODE_SELECTION_LABEL_TEST_ID }, "Hours Worked"),
            react_1.default.createElement(PayCodePolicyModal_1.CheckPayCodePolicyLink, { payCodePolicyInfo: props.payCodePolicyInfo, payCodesInfo: props.payCodesInfo })),
        react_1.default.createElement(Select_1.Select, { dataTestId: exports.PAY_CODE_SELECTION_TEST_ID, id: exports.PAY_CODE_SELECTION_TEST_ID, labelId: exports.PAY_CODE_SELECTION_LABEL_TEST_ID, options: props.isWECoreSelfClassification
                ? props.payCodePolicyInfo.payCodePolicies.map((policy) => policy.payCode)
                : props.payCodesInfo.payCodes.map((payCode) => payCode.description), value: props.selectedPayCode, onChange: props.isWECoreSelfClassification
                ? (updatedPayCode) => (0, exports.updateSelectedPayCodeInPayDataList)(updatedPayCode, props)
                : (updatedPayCode) => (0, exports.updateSelectedPayCodeInPayCodeList)(updatedPayCode, props), disabled: props.isDisabled })));
};
exports.PayCodeSelection = PayCodeSelection;
const updateSelectedPayCodeInPayDataList = (updatedPayCode, props) => {
    props.setPayDataList((payDataList) => {
        const updatedPayDataList = [...payDataList];
        const prevPayData = payDataList[props.payDataIndex];
        const updatedPayData = Object.assign(Object.assign({}, prevPayData), { salaryCodesDescription: [updatedPayCode] });
        updatedPayDataList[props.payDataIndex] = updatedPayData;
        return updatedPayDataList;
    });
};
exports.updateSelectedPayCodeInPayDataList = updateSelectedPayCodeInPayDataList;
const updateSelectedPayCodeInPayCodeList = (updatedPayCode, props) => {
    props.setPayCodeList((payCodeList) => {
        const updatedPayCodeList = [...payCodeList];
        const prevPayCode = payCodeList[props.payDataIndex];
        const updatedPayCodeSummary = Object.assign(Object.assign({}, prevPayCode), { payCodeName: updatedPayCode });
        updatedPayCodeList[props.payDataIndex] = updatedPayCodeSummary;
        return updatedPayCodeList;
    });
};
exports.updateSelectedPayCodeInPayCodeList = updateSelectedPayCodeInPayCodeList;
